export const setReadBy = (message, state) => {
  message.readBy = [];
  for (const lastReadMessage of state.lastReadMessages) {
    if (
      lastReadMessage.updatedAt >= message.createdAt &&
      message.userId !== lastReadMessage.userId
    ) {
      const item = {
        userId: lastReadMessage.userId,
        firstName: lastReadMessage.firstName || '',
        lastName: lastReadMessage.lastName || '',
        readAt:
          lastReadMessage.messageId === message.id
            ? lastReadMessage.updatedAt
            : null,
      };
      message.readBy.push(item);
    }
  }
  return message;
};
